import { Link } from 'react-router-dom';
import { getPopularComics, formatViews } from '@/mocks/comics';

export default function PopularRankingSection() {
  const popular = getPopularComics(8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            人气排行
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            全网热度最高的<strong>韩国漫画大全</strong>，<strong>免费阅读</strong>就在韩漫网站
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {popular.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-background-50/80 transition-all duration-300 group cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center text-background-50 font-heading font-bold text-lg">
                {index + 1}
              </div>
              <div className="flex-shrink-0 w-14 h-20 rounded-md overflow-hidden bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                <div className="flex items-center gap-3 mt-1.5">
                  <span className="text-xs text-accent-500 font-medium">
                    <i className="ri-star-fill text-[10px]"></i> {comic.rating}
                  </span>
                  <span className="text-xs text-foreground-400">
                    {formatViews(comic.views)} 阅读
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}